export default __webpack_public_path__ + "static/media/Asset 14.2ad520f9.png";